import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

export interface OrderPdfParam extends ApiParameter {
    orderNumber: string;
}

const OrderPdfURL = "api/printorderdetail/getorderpdf";

export function getOrderPdf(parameter: OrderPdfParam) {
    return get<any>(`${OrderPdfURL}`, parameter);
}
